import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import ZeroComplete from './zero-complete';

function CalibrationPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Performing Zero"
      content="Zero calibration in progress."
      onExit={() => onComponent(<ZeroComplete />)}
    />
  );
}

export default CalibrationPB;
